import { Panel } from 'primereact/panel';
import { RepresentanteApoderado } from '../RepresentanteApoderado';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const DatosPJ = ({ toast, back, next, id, permss, catalogos, soloLectura }) => {

  return (
    <>
      <Panel header="DATOS DEL REPRESENTANTE LEGAL/ APODERADO/ BENEFICIARIO FINAL Y SUS RESPECTIVOS CÓNYUGUES (DE SER EL CASO):" className="panel-ficha">
        <RepresentanteApoderado toast={toast} tipo="clientepj" id={id} permss={permss} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} soloLectura={soloLectura} />
      </Panel>
      <br />
      <BottomActionBar onPrev={back} onNext={next} isReadOnly={true} />
    </>
  );
}
